export interface Schematic {
  id: string;
  kind: string;
  packageSuffix?: string;
  name?: string;
  nullable?: boolean;
  collapsed?: boolean;
  children?: Schematic[];
  childName?: string;
}

export function createSchematic(schematic?: Partial<Schematic>): Schematic {
  return {
    id: self.crypto.randomUUID(),
    kind: "",
    ...schematic,
  };
}

export function moveSchematic(
  schematic: Schematic,
  moveId: string,
  parentId: string,
  sortBefore: string | null,
): Schematic {
  const { schematic: schematicWithoutFrom, removed: fromSchematic } = remove(
    schematic,
    moveId,
  );
  return add(schematicWithoutFrom!, fromSchematic!, parentId, sortBefore);
}

function remove(
  schematic: Schematic,
  id: string,
): { schematic: Schematic | null; removed: Schematic | null } {
  if (schematic.id === id) {
    return { schematic: null, removed: schematic };
  }
  if (!schematic.children) {
    return { schematic, removed: null };
  }
  const newChildren = [];
  let removed: Schematic | null = null;
  for (const child of schematic.children) {
    const { schematic: newChild, removed: removedChild } = remove(child, id);
    if (newChild !== null) {
      newChildren.push(newChild);
    }
    if (removedChild !== null) {
      removed = removedChild;
    }
  }
  return { schematic: { ...schematic, children: newChildren }, removed };
}

function add(
  schematic: Schematic,
  toAdd: Schematic,
  parentId: string,
  sortBefore: string | null,
): Schematic {
  if (schematic.id === parentId) {
    const oldChildren = schematic.children ?? [];
    const index =
      sortBefore === null
        ? oldChildren.length
        : oldChildren.findIndex((c) => c.id === sortBefore);
    return {
      ...schematic,
      children: [
        ...oldChildren.slice(0, index),
        toAdd,
        ...oldChildren.slice(index),
      ],
    };
  }
  if (!schematic.children) {
    return schematic;
  }
  return {
    ...schematic,
    children: schematic.children.map((child) =>
      add(child, toAdd, parentId, sortBefore),
    ),
  };
}
